module.exports = __webpack_public_path__ + "static/track_your_progress_mobile-af00181243705170424c102d8d2a50df.jpg";